import React from 'react';
import Banner from '../components/banner';
import About from '../components/about';
import WhyChooseUs from '../components/WhyChooseUs';
import LookingLoan from '../components/looking-loan';
import LoanCalculator from '../components/loan-calculator';
import LoanFeatures from '../components/loan-features';
import LoanStep from '../components/loan-step';
import EligibilityCriteria from '../components/EligibilityCriteria';
import RequiredDocuments from '../components/RequiredDocuments';
import LoanTips from '../components/LoanTips';

const Home = () => {
  return (
    <>
      <Banner />
      <About />
      <WhyChooseUs />     
      <LookingLoan />
      <LoanCalculator />
      <LoanFeatures />
      <LoanStep />
      <EligibilityCriteria />
      <RequiredDocuments />
      <LoanTips />

    </>
  );
};

export default Home;
